import { graphql } from "@/lib/gql/__generated__";

export const MAGAZINE_TAG_FOR_DESIGN_MAGAZINE_EDIT = graphql(/* GraphQL */ `
	query MagazineTagForDesignMagazineEdit {
		magazineTagGetPopularTag {
			id
			list
		}
		magazineTagLocationTag {
			id
			list {
				tag
				children {
					tag
					children {
						tag
					}
				}
			}
		}
	}
`);
